<template>
	<div class="flow-tour-step">
		<div class="flow-tour-body">
			<slot />
		</div>
		<div class="flow-tour-footer">
			<slot name="footer" />
		</div>
		<div data-popper-arrow class="flow-step-arrow" />
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({});
</script>
<style lang="scss">
div.flow-tour-step {
	background-color: var(--dashboard-element);
	min-height: 100px;
	width: 350px;
	border-radius: 8px;

	display: flex;
	flex-direction: column;
	padding: 20px;
	// margin: 8px !important;
	> * + *:not(div.flow-step-arrow) {
		margin-top: 20px;
	}

	z-index: 104;

	> div.flow-step-arrow {
		border-width: 10px 10px 10px 10px;
		border-left-color: transparent;
		border-right-color: transparent;
		border-top-color: transparent;
		border-bottom-color: transparent;
		border-style: solid;
		width: 0px;
		height: 0px;
	}

	&[data-popper-placement^="right"] {
		> div.flow-step-arrow {
			right: 100%;
			border-right-color: var(--dashboard-element);
			border-left-width: 0px;
			top: -16px !important;
		}
	}
	&[data-popper-placement^="bottom"] {
		> div.flow-step-arrow {
			bottom: 100%;
			border-bottom-color: var(--dashboard-element);
			border-top-width: 0px;
			// left: -8px !important;
		}
	}
	&[data-popper-placement^="left"] {
		> div.flow-step-arrow {
			left: 100%;
			border-left-color: var(--dashboard-element);
			border-right-width: 0px;
			top: -16px !important;
		}
	}
	&[data-popper-placement^="top"] {
		> div.flow-step-arrow {
			top: 100%;
			border-top-color: var(--dashboard-element);
			border-bottom-width: 0px;
			// left: -8px !important;
		}
	}
}
</style>
